import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-webhook",
  "use": "channel-webhook-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"channel-webhook\"><path d=\"M14.295 9.003l3.75 3.75-3.75 3.75m-4.5-7.5l-3.75 3.75 3.75 3.75m12.705 5.25a1.5 1.5 0 01-1.5 1.5H3a1.5 1.5 0 01-1.5-1.5v-19.5A1.5 1.5 0 013 .753h15.045a1.5 1.5 0 011.048.427l2.955 2.882c.29.282.452.67.452 1.074v16.617z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-webhook.svg
// module id = VSGH
// module chunks = 39 44